import React from 'react';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { Image } from '../../../components/UI-CHAKRA/Image';
import standAloneQrCode from '../../../assets/images/stand-alone-prescriber-central-qr-code.svg';
import { ReactComponent as MevoLogo } from '../../../assets/images/logo/mevo-logo.svg';
import { Button } from '../../../components/UI-CHAKRA/Button';

export function StandaloneCTA() {
  return (
    <Box p={'20px'} pb={0} width={'100%'}>
      <Box borderRadius={'20px'} bg={'#FFE4EB'} p={'15px'} w={'100%'} m={'10px 0'}>
        <Flex w={'100%'} justifyContent={'center'}>
          <Image src={standAloneQrCode} w={'100%'} h={'100%'} borderRadius={'10px'} mb={'10px'} />
        </Flex>

        <Text fontWeight={'bold'} color={'#3D0E6B'} lineHeight={'17px'} fontSize={'14px'}>
          Aproveite e prescreva do seu celular ou do computador.
        </Text>

        <Flex gap={'10px'} mt={'10px'}>
          <Flex
            w={'50px'}
            h={'50px'}
            bg={'#FFB6BF'}
            borderRadius={'10px'}
            p={'10px'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <MevoLogo />
          </Flex>

          <Text color={'#3D0E6B'} lineHeight={'17px'} fontSize={'12px'}>
            <b>Novidade: </b>Agora você pode instalar o aplicativo Mevo Profissionais no seu celular.
          </Text>
        </Flex>

        <Button
          fontSize={'14px'}
          mt={'10px'}
          w={'100%'}
          borderRadius={'20px'}
          backgroundColor={'#fff'}
          color={'#3D0E6B'}
          variant={'outline'}
          borderColor={'#FFB6BF'}
          onClick={() => {
            window.open(
              'https://receita.mevosaude.com.br/?utm_source=CTA&utm_medium=b2b&utm_campaign=doctor_menu',
              '_blank',
              'noopener'
            );
          }}
        >
          Acessar
        </Button>
      </Box>
    </Box>
  );
}
